// libs
import cx from 'classnames';
import React, { memo } from 'react';
// styles
import styles from './Line.module.scss';
function Line({ className }) {
    return React.createElement("div", { className: cx(styles.line, className) });
}
export default memo(Line);
